export default [
  {
    path: window.pathApp + '/p',
    name: 'p.short',
    component: () => import('@/components/Produtos/Path'),
    redirect: window.pathApp + "/produtos/contribuicao",
    meta: {
      login: false,
      avisoCarrinho: true,
      title: "Produto",
    },
    children: [
      {
        path: ':short',
        name: 'produtos.short',
        component: () => import('@/components/Produtos/Visualizacao'),
        meta: {
          login: false,
          avisoCarrinho: true,
          title: "Produto",
        },
      }
    ]
  },
  {
    path: window.pathApp + '/produtos',
    name: 'produtos',
    component: () => import('@/components/Produtos/Path'),
    redirect: window.pathApp + "/produtos/contribuicao",
    meta: {
      login: false,
      avisoCarrinho: true,
      title: "Produtos",
    },
    children: [
      {
        path: 'contribuicao',
        name: 'produtos.contribuicao',
        component: () => import('@/components/Produtos/Visualizacao'),
        meta: {
          login: false,
          avisoCarrinho: true,
          title: "Contribuição",
        },
      },
      {
        path: 'itens/:tipo',
        name: 'produtos.listagem',
        component: () => import('@/components/Produtos/Listagem'),
        meta: {
          login: false,
          avisoCarrinho: true,
          title: "Produtos",
        },
      },
      {
        path: ':id/:nome',
        name: 'produtos.visualizacao',
        component: () => import('@/components/Produtos/Visualizacao'),
        meta: {
          login: false,
          avisoCarrinho: true,
          title: "Produto",
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/produtos.js